/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProfileUnsubscribeIdGet$Params {
  id: string;
}

export function profileUnsubscribeIdGet(http: HttpClient, rootUrl: string, params: ProfileUnsubscribeIdGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, profileUnsubscribeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VitalScoreStrictHttpResponse<void>;
    })
  );
}

profileUnsubscribeIdGet.PATH = '/Profile/Unsubscribe/{id}';
